import { FIVE_MINUTES_MS, HALF_MINUTE_MS } from "helpers/time";
import { ISOstring } from "model/modelTypes";
import { TimeRange } from "model/report/dateRange";

export type DateRangeStateType = {
  start: ISOstring | null;
  finish: ISOstring | null;
  calcStart?: () => ISOstring;
  calcFinish?: () => ISOstring;
  range: TimeRange;
};

export const defaultDateRangeState: DateRangeStateType = {
  start: null,
  finish: null,
  calcStart: undefined,
  calcFinish: undefined,
  range: TimeRange.allTime,
};

export type CompareToDateRangeStateType = {
  startPrevious?: ISOstring | null;
  finishPrevious?: ISOstring | null;
  calcStartPrevious?: () => ISOstring;
  calcFinishPrevious?: () => ISOstring;
  labelPrevious: string;
};

export const defaultCompareToDateRangeState: CompareToDateRangeStateType = {
  startPrevious: undefined,
  finishPrevious: undefined,
  calcStartPrevious: undefined,
  calcFinishPrevious: undefined,
  labelPrevious: "",
};

export const liveUpdateEveryMs = HALF_MINUTE_MS;

export const reporterRealtimeUpdateEveryMs = FIVE_MINUTES_MS;
